import styled, { createGlobalStyle } from 'styled-components';

export const RestaurantDetailsStyle = createGlobalStyle`
  .restaurant-details-modal p {
    max-width: 40rem;
  }
`;

export const StoreDetails = styled.a`
  cursor: pointer;
  text-decoration: underline;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Group = styled.div`
  width: 100%;
  text-align: left;
  padding: 0.5em;
  line-height: 1.5rem;

  ${Styles.desktop`
    width: 50%;
    padding: 1.5em;
    line-height: 1.75rem;
  `};
`;
